import React from 'react';
import ResultsTable from '../ResultsTable.js';
import { FiltersState } from '../../hooks/useFilters';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { RelevanceFilter } from '../../components/search/RelevanceFilters';
import { SearchProgress } from '../hooks/useSearchProgress';

interface ResultsCardProps {
  data: any;
  loading: boolean;
  loadingMore?: boolean;
  error: any;
  filters: FiltersState;
  onPageChange: (page: number) => void;
  onToggleFilters?: () => void;
  filtersVisible?: boolean;
  onSearch?: () => void;
  vacancyTitle?: string;
  sourcePositionId?: number | null;
  selectedRelevance?: RelevanceFilter;
  searchProgress?: SearchProgress | null;
  onCancelSearch?: () => void;
  onAiScoresChange?: (items: any[]) => void;
}

const ResultsCard: React.FC<ResultsCardProps> = ({
  data,
  loading,
  loadingMore,
  error,
  filters,
  onPageChange,
  onToggleFilters,
  filtersVisible,
  onSearch,
  vacancyTitle,
  sourcePositionId,
  selectedRelevance,
  searchProgress,
  onCancelSearch,
  onAiScoresChange
}) => {
  const handleExpandedCommentChange = React.useCallback((expanded: boolean) => {
    if (!onToggleFilters || filtersVisible === undefined) return;
    // Разворачиваем -> скрыть фильтры. Сворачиваем -> показать фильтры.
    if (expanded && filtersVisible) {
      onToggleFilters();
    } else if (!expanded && !filtersVisible) {
      onToggleFilters();
    }
  }, [onToggleFilters, filtersVisible]);

  const isLoadingOrError = loading || error;
  
  return (
    <div className={`bg-transparent relative px-2 rounded-xl shrink-0 w-full ${isLoadingOrError ? 'flex-1 flex flex-col' : ''}`}>
      <div className={`flex flex-col items-start relative w-full ${isLoadingOrError ? 'flex-1' : ''}`}>
        <div className={`w-full ${isLoadingOrError ? 'flex-1 flex flex-col' : ''}`}>
          <ResultsTable
            data={data}
            loading={loading}
            loadingMore={loadingMore}
            error={error}
            filters={filters}
            onPageChange={onPageChange}
            onExpandedCommentChange={handleExpandedCommentChange}
            sourcePositionId={sourcePositionId}
            vacancyTitle={vacancyTitle}
            selectedRelevance={selectedRelevance}
            searchProgress={searchProgress}
            onCancelSearch={onCancelSearch}
            onAiScoresChange={onAiScoresChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ResultsCard;
